import React from 'react'

import { APP_STORE_URL, GOOGLE_PLAY_URL, USER_EMAIL } from 'app-constants'
import TabletAppStoreButton from 'assets/icons/app-store-tablet.svg'
import AppStoreButton from 'assets/icons/app-store.svg'
import TabletGooglePlayStoreButton from 'assets/icons/google-play-tablet.svg'
import GooglePlayButton from 'assets/icons/google-play.svg'
import { withClickTrack } from 'components/Trackers/ClickTracker'
import getDefaultEventData from 'components/Trackers/defaults'
import { isAndroid } from 'components/Trackers/platform'
import { TRACKER_IDS } from 'components/Trackers/trackerIDs'
import { TestIDs } from 'test/utils/testIds'
import { getButtonTappedEvent } from 'utils/analytics'

import {
  DownloadAppButton,
  DownloadAppButtonContainer,
  DownloadAppButtonImage,
} from './styled-components'

export const TrackedDownloadAppButton = ({ isTablet = false }) => {
  const buttonInfo = getButtonInfo(isTablet)
  const fields = {
    ...getButtonTappedEvent(buttonInfo.trackerId),
    ...getDefaultEventData('Button Tapped'),
    email: window.sessionStorage.getItem(USER_EMAIL),
  }
  const TrackedAppStoreButton = withClickTrack<any, any>(fields)(DownloadAppButton)
  return (
    <DownloadAppButtonContainer>
      <TrackedAppStoreButton key={0} href={buttonInfo.href} data-testid={buttonInfo.testId}>
        <DownloadAppButtonImage src={buttonInfo.image} alt={buttonInfo.altText} />
      </TrackedAppStoreButton>
    </DownloadAppButtonContainer>
  )
}

const getButtonInfo = isTablet => {
  if (isAndroid()) {
    return getAndroidButtonInfo(isTablet)
  }
  return getAppleButtonInfo(isTablet)
}

// @todo: curtis fix google play tablet button
const getAndroidButtonInfo = (isTablet: boolean) => ({
  image: isTablet ? TabletGooglePlayStoreButton : GooglePlayButton,
  href: GOOGLE_PLAY_URL,
  trackerId: TRACKER_IDS.DIRECT_TO_MOBILE.GOOGLE_PLAY_BUTTON,
  testId: TestIDs.DIRECT_TO_MOBILE.GOOGLE_PLAY_BUTTON,
  altText: 'Google Play',
})

const getAppleButtonInfo = (isTablet: boolean) => ({
  image: isTablet ? TabletAppStoreButton : AppStoreButton,
  href: APP_STORE_URL,
  trackerId: TRACKER_IDS.DIRECT_TO_MOBILE.APP_STORE_BUTTON,
  testId: TestIDs.DIRECT_TO_MOBILE.APP_STORE_BUTTON,
  altText: 'Apple Store',
})
